export const WIDGET_EVENT_CLOSE_MODAL = "customDeliveryOption:widget:modal:close";
export const WIDGET_EVENT_SET_ADDRESS = "customDeliveryOption:address:set";
export const WIDGET_EVENT_WIDGET_CRASH = "customDeliveryOption:widget:crash";
